import { useEffect } from 'react';
import { SITE_LOGO_URL } from '../config/branding';

/**
 * Custom hook for managing SEO meta tags
 * Updates document title and meta tags dynamically
 */
function useSEO({ title, description, image, url, type = 'website' }) {
  useEffect(() => {
    // Update document title
    if (title) {
      document.title = title;
    }

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      if (!content) return;
      
      const attribute = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, name);
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    };

    // Update description
    updateMetaTag('description', description);
    updateMetaTag('og:description', description, true);

    // Update title
    updateMetaTag('og:title', title, true);
    updateMetaTag('twitter:title', title, true);

    // Update image
    if (image) {
      updateMetaTag('og:image', image, true);
      updateMetaTag('twitter:image', image, true);
    }

    // Update URL
    if (url) {
      updateMetaTag('og:url', url, true);
      updateMetaTag('twitter:url', url, true);
    }

    // Update type
    updateMetaTag('og:type', type, true);

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (url) {
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', url);
    } else if (canonical) {
      canonical.remove();
    }

    if (image) {
      const isSiteLogo = image === SITE_LOGO_URL || image.endsWith('/images/logo_white.png');
      updateMetaTag('og:image:width', isSiteLogo ? '1080' : '1200', true);
      updateMetaTag('og:image:height', isSiteLogo ? '1080' : '630', true);
    }
  }, [title, description, image, url, type]);
}

export default useSEO;

